import * as React from 'react';
import { useCallback } from 'react';

export type UsePagination = (initialIndex: number) => { currentIndex: number; handleChange: (index: number) => void };

export const usePagination: UsePagination = initialIndex => {
	const [paginationIndex, setPaginationIndex] = React.useState(initialIndex ?? 0);

	const handleChange = useCallback(
		(index: number) => {
			setPaginationIndex(index);
		},
		[paginationIndex]
	);

	return {
		currentIndex: paginationIndex,
		handleChange
	};
};
